import React, { useEffect, useState } from "react";
import { useAuth } from "../lib/auth";
import { api, fmtPoints } from "../lib/api";
import WalletCard from "../components/WalletCard";
import { ArrowDownLeft, ArrowUpRight } from "lucide-react";

export default function WalletPage() {
    const { customer, wallet } = useAuth();
    const [txs, setTxs] = useState([]);
    const [filter, setFilter] = useState("all");
    useEffect(() => {
        api.get("/api/wallet/transactions?limit=100").then((r) => setTxs(r.data.transactions || []));
    }, []);

    const filtered = filter === "all" ? txs : txs.filter((t) => t.type === filter);

    return (
        <div className="pb-28">
            <header className="px-5 pt-7">
                <h1 className="font-display text-2xl font-bold">My Wallet</h1>
                <p className="text-[#6b7280] text-sm">All your points & transactions in one place</p>
            </header>
            <div className="px-5 mt-5">
                <WalletCard customer={customer} wallet={wallet} />
            </div>

            <div className="px-5 mt-6 grid grid-cols-3 gap-3">
                <Stat label="Lifetime earned" value={fmtPoints(wallet?.lifetime_earned || 0)} />
                <Stat label="Lifetime redeemed" value={fmtPoints(wallet?.lifetime_redeemed || 0)} />
                <Stat label="Tier points" value={fmtPoints(wallet?.tier_points || 0)} />
            </div>

            <div className="px-5 mt-6">
                <div className="flex gap-2 mb-3">
                    {[
                        ["all", "All"],
                        ["earn", "Earned"],
                        ["redeem", "Redeemed"],
                    ].map(([k, l]) => (
                        <button
                            key={k}
                            data-testid={`tx-filter-${k}`}
                            onClick={() => setFilter(k)}
                            className={`px-4 py-1.5 rounded-full text-sm transition-all ${
                                filter === k
                                    ? "bg-[#c9a959] text-black font-semibold"
                                    : "bg-[#f9fafb] text-[#374151] border border-[rgba(11,20,55,0.10)]"
                            }`}
                        >
                            {l}
                        </button>
                    ))}
                </div>
                <div className="space-y-2">
                    {filtered.length === 0 && (
                        <div className="fx-card p-6 text-center text-[#6b7280] text-sm">No transactions</div>
                    )}
                    {filtered.map((t) => (
                        <div key={t.id} className="fx-card p-3 flex items-center gap-3">
                            <div
                                className={`w-10 h-10 rounded-xl flex items-center justify-center ${
                                    t.type === "earn"
                                        ? "bg-[#c9a959]/15 text-[#c9a959]"
                                        : "bg-[#ff4d4d]/15 text-[#ff4d4d]"
                                }`}
                            >
                                {t.type === "earn" ? <ArrowDownLeft size={18} /> : <ArrowUpRight size={18} />}
                            </div>
                            <div className="flex-1">
                                <p className="text-sm font-medium">{t.description || t.source}</p>
                                <p className="text-[11px] text-[#9ca3af]">
                                    {new Date(t.created_at).toLocaleString("en-IN")} • {t.source}
                                </p>
                            </div>
                            <span
                                className={`font-display font-bold ${
                                    t.type === "earn" ? "text-[#c9a959]" : "text-[#ff4d4d]"
                                }`}
                            >
                                {t.type === "earn" ? "+" : "-"}
                                {fmtPoints(t.amount_points)}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

function Stat({ label, value }) {
    return (
        <div className="fx-card p-3 text-center">
            <p className="text-[10px] uppercase tracking-widest text-[#6b7280]">{label}</p>
            <p className="font-display text-base font-bold mt-1">{value}</p>
        </div>
    );
}
